import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllRfid() {
    try {
        let res = await client.get("/rfid/cms");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}
async function fetchAllRfidByRackId(rack_id) {
    try {
        let res = await client.get(`/rfid?rack_id=${rack_id}`);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOneRfid(id) {
    try {
        let res = await client.get("/rfid/rfid_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createRfid(rfid_number, name) {
    try {
        let res = await client.post("/rfid/create", {
            rfid_number: rfid_number,
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateRfid(id, name) {
    try {
        let res = await client.post("/rfid/update", {
            id: id,
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function exportRfid() {
    try {
        let res = await client.get("/rfid/download", {
            responseType: 'blob'
        });

        // Extract filename from content-disposition header
        const contentDisposition = res.headers['content-disposition'];
        const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = fileNameRegex.exec(contentDisposition);
        const filename = matches && matches[1] ? matches[1].replace(/['"]/g, '') : 'data-rfid.xlsx';

        // Create a temporary URL for the file
        const url = window.URL.createObjectURL(new Blob([res.data]));

        // Create a link and click it to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set filename
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object after the download
        window.URL.revokeObjectURL(url);
    } catch (err) {
        throw ErrorException(err);
    }
}

async function importRfid(file) {
    const form = new FormData();
    form.append("file", file);

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/rfid/upload", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deleteRfid(id) {
    try {
        let res = await client.delete("/rfid/rfid_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllRfid,
    fetchAllRfidByRackId,
    fetchOneRfid,
    createRfid,
    updateRfid,
    exportRfid,
    importRfid,
    deleteRfid,
};
